import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Concept from "@/components/Concept";
import Kitchens from "@/components/Kitchens";
import Difference from "@/components/Difference";
import Stats from "@/components/Stats";
import HowItWorks from "@/components/HowItWorks";
import Gallery from "@/components/Gallery";
import FAQ from "@/components/FAQ";
import ClosingCTA from "@/components/ClosingCTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div id="top" className="bg-[#141416] text-white" data-testid="app-root">
      <div className="noise-overlay pointer-events-none fixed inset-0 z-[60] opacity-[0.05]" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Concept />
        <Kitchens />
        <Difference />
        <Stats />
        <HowItWorks />
        <Gallery />
        <FAQ />
        <ClosingCTA />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
